<template>
  <div id="modalCreateEditUserTeam" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Usuário</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.name.$errors.length }"
                  placeholder="Nome Completo"
                  v-model="v$.user.name.$model"
                />
                <span
                  v-if="v$.user.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.user.name.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.user.name.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Cargo: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.role.$errors.length }"
                  placeholder="Cargo"
                  v-model="v$.user.role.$model"
                />
                <span
                  v-if="v$.user.role.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Função: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.function.$errors.length }"
                  placeholder="Função"
                  v-model="v$.user.function.$model"
                />
                <span
                  v-if="v$.user.function.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  E-mail: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.email.$errors.length }"
                  placeholder="usuario@email.com.br"
                  v-model="v$.user.email.$model"
                />
                <span
                  v-if="v$.user.email.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.user.email.email.$invalid"
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">Telefone:</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.phone.$errors.length }"
                  placeholder="(00) 98888-8888"
                  v-model="v$.user.phone.$model"
                  v-maska="['(##) ####-####', '(##) #####-####']"
                />
                <span
                  v-if="v$.user.phone.minLength.$invalid"
                  class="invalid-feedback"
                >
                  Formato de telefone inválido <br />
                  Ex: (00) 98888-8888 / (00) 8888-8888
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Vai Acessar a Plataforma? <span class="text-danger">*</span>
                </label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="platformAccessNo"
                      value="0"
                      v-model="user.platformAccess"
                    />
                    <label class="form-check-label" for="platformAccessNo">
                      Não
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      class="form-check-input"
                      id="platformAccessYes"
                      value="1"
                      v-model="user.platformAccess"
                    />
                    <label class="form-check-label" for="platformAccessYes">
                      Sim
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-sm btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, maxLength } from '@vuelidate/validators'
import { maska } from 'maska'
import { showModal, hideModal } from '@/utils/modal'
import StatusEnum from '@/enum/statusEnum'
import ProfileEnum from '@/enum/profileEnum'

export default {
  name: 'CreateEditUserTeamModal',

  props: {
    userId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  directives: { maska },

  data() {
    return {
      user: {
        name: '',
        role: '',
        function: '',
        email: '',
        phone: '',
        platformAccess: '',
        status: StatusEnum.AGUARDANDO,
        profiles: [
          {
            id: ProfileEnum.PREENCHIMENTO,
          },
        ],
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.userId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getProfiles() {
      try {
        this.profiles = await this.$store.dispatch('getProfiles')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getUser() {
      try {
        this.user = await this.$store.dispatch('getUser', this.userId)
        showModal('modalCreateEditUserTeam')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.userId) {
            response = await this.$store.dispatch('updateUser', this.user)
          } else {
            response = await this.$store.dispatch('saveUser', this.user)
          }

          hideModal()

          if (response.data && response.data.userId) {
            this.$emit('closeModal', response.data.userId)
          } else {
            this.$emit('closeModal', true)
          }

          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      user: {
        name: {
          required,
          minLength: minLength(8),
        },
        role: {
          required,
        },
        function: {
          required,
        },
        email: {
          required,
          email,
        },
        phone: {
          minLength: minLength(14),
          maxLength: maxLength(15),
        },
        platformAccess: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.userId) {
      this.getUser()
    } else {
      showModal('modalCreateEditUserTeam')
    }
  },
}
</script>
